import { Card, CardContent, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';

import { NumberedList } from '../../../../general/components/numbered-list';
import { RequiredText } from '../../../../general/components/required-text';

const STATEMENT_TYPES = ['Balance sheet', 'Income statement', 'Cash flow statement'];

type Props = {
  years: string;
};

const FinancialStatementRequirements: FC<Props> = ({ years }: Props) => (
  <Card variant="outlined">
    <CardContent>
      <Stack spacing={2}>
        <Typography variant="subtitle1-medium">What to include</Typography>

        <Typography variant="body2">
          Upload statements for <strong>{years}</strong>. For each year, upload either a combined file or separate
          files, including:
        </Typography>

        <NumberedList listValues={STATEMENT_TYPES} />

        <Typography variant="body2">
          Audited statements are preferred. <strong>At least one year must be audited.</strong>
        </Typography>

        <Typography variant="caption">
          <RequiredText>PDF only</RequiredText>
        </Typography>
      </Stack>
    </CardContent>
  </Card>
);

export { FinancialStatementRequirements };
